<template>
  <div @click="toggleOpenOptions(null)">
    <library-header :removeSearchBar="true"/>
    <section class="library-content has-side-bar">
      <aside class="content-approval-sidebar">
        <library-sidebar/>
      </aside>
      <filter-bar/>
      <div class="library-main-content content-approval">
        <header class="content-approval-header">
          <h2 class="content-approval-title">
            {{ $t('CONTENT_FOR_APPROVAL') }}
          </h2>
          <content-approval-header
            @updateSelectedEntryStatus="updateSelectedEntryStatus"
          />
        </header>
        <template v-if="displayedEntriesArr.length">
          <section class="library-result-list">
            <entry-row
              :collectionEntry="entry"
              v-for="entry in displayedEntriesArr.slice(startIndex, endIndex)"
              :key="entry.data.id"
            />
          </section>
        </template>
        <section v-else class="no-content-approval">
          <img src="@/assets/images/no-content.svg" class="icon" alt=""/>
          <p class="text">{{ $t('NO_' + selectedEntryStatus + '_CONTENT') }}</p>
        </section>
        <div class="pages-bottom">
          <pagination-options
            :openOptions="openOptions"
            @toggleOpenOptions="toggleOpenOptions(true)"
            :startIndex="startIndex+1"
            :numOfResult="displayedEntriesArr.length"
            :endIndex="endIndex"
            :selectedCount="selectedCount"
            @goNext="goNext" @goPrev="goPrev"
            @changeSelectedCount="changeSelectedCount"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import entryRow from '@/components/entry-row'
import ContentApprovalHeader from '@/components/content-approval-header.vue'
import FilterBar from '@/components/filter-bar'
import LibraryHeader from '@/components/library-header'
import { entryApprovalStatuses, paginationOptions } from '@/constants'
import librarySidebar from '@/components/sidebar'
import PaginationOptions from '@/components/pagination-options'
import { changeSelectedCount, goNext, goPrev, toggleOpenOptions } from '@/paginationFunctions'

export default {
  name: 'content-approval',

  components: { PaginationOptions, ContentApprovalHeader, FilterBar, LibraryHeader, entryRow, librarySidebar },

  data () {
    return {
      openOptions: false,
      startIndex: 0,
      selectedCount: paginationOptions[0],
      selectedEntryStatus: entryApprovalStatuses.PENDING
    }
  },
  beforeMount () {
    if (this.$route.query.searchText) {
      this.$store.dispatch('setSearchWord', this.$route.query.searchText)
    }
    if (this.$route.query.filters) {
      const filtersTOAdd = []
      const arrayOfFilters = JSON.parse(this.$route.query.filters)
      for (const filter of arrayOfFilters) {
        filtersTOAdd.push(filter.split('-'))
      }
      this.$store.dispatch('setFilltersFromRouteAfterRefresh', filtersTOAdd)
    }
    if (this.$route.query.filters) {
      this.$store.dispatch('getFilterCollectionEntries')
    }
  },

  computed: {
    ...mapGetters(['getEntriesByStatus']),
    ...mapState({
      searchWord: state => state.collections.searchWord
    }),
    // Returns an array that contains all the entries that match the selected status
    displayedEntriesArr () {
      return this.getEntriesByStatus(this.selectedEntryStatus, this.searchWord)
    },
    endIndex () {
      const index = this.startIndex + this.selectedCount
      if (index > this.displayedEntriesArr.length) {
        return this.displayedEntriesArr.length
      } else {
        return index
      }
    }
  },

  methods: {
    toggleOpenOptions,
    goNext,
    goPrev,
    changeSelectedCount,
    updateSelectedEntryStatus (status) {
      this.selectedEntryStatus = status
    }
  }
}

</script>

<style lang="scss" scoped>
.icon {
  width: 23px;
  height: 23px;
}

.pages-bottom {
  position: fixed;
  bottom: 0;
  inset-inline-end: 70px;
  width: 90%;
  background: #fff;
  margin-bottom: unset;
}
</style>
